export default class EmailCreateRequest {
    constructor(locale, supportedLocales) {
        this.translations = [];
        supportedLocales.forEach((element) => {
            this.translations[element] = {
                emailType: '',
                subject: '',
                content: '',
                photos: '',
                parameters: '',
                description: '&nbsp',
            };
        });
    }

    static assign(from, to) {
        if (from) {
            to.locale = from.locale;
            to.description = from.description;
            to.subject = from.subject;
            to.emailType = from.emailType;
            to.content = from.content;
        } else {
            to = new EmailCreateRequest();
        }
    }

    static copy(from) {
        const to = new EmailCreateRequest();
        EmailCreateRequest.assign(from, to);
        return to;
    }
}
